import { useEffect, useState } from 'react';
import { PUBLIC_URL } from './env';

const useFingerPrint = (env: 'prod' | 'dev') => {
  const [fingerPrint, setFingerPrint] = useState('');

  useEffect(() => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL[env]}/iovation-loader-5.x.js`;
    head?.appendChild(script);
    window.IGLOO = window.IGLOO || {
      enable_rip: true, // Enable Real IP protection.
      enable_flash: false, // Disable flash
      install_flash: false, // Don't ask user to install flash
      loader: {
        version: 'general5', // Non-experimental 5.x updates
        fp_static: false, // Don't load 1st party resources
      },
    };
    let timeoutId: ReturnType<typeof setTimeout>;

    function useBlackboxString() {
      if (typeof window.IGLOO.getBlackbox !== 'function') {
        return;
      }

      const bbData = window.IGLOO.getBlackbox();
      if (bbData.finished) {
        clearTimeout(timeoutId);
        const blackBoxString = bbData.blackbox;
        setFingerPrint(encodeURIComponent(blackBoxString));
      }
    }
    timeoutId = setInterval(useBlackboxString, 500);
    return () => {
      head?.removeChild(script);
    };
  }, []);

  return [fingerPrint];
};

export default useFingerPrint;
